import { ESortType } from "@adgm/cross-models";
import type { IAutoInvestCoinItem } from "@aspen/model";

export const IS_OPEN_MUTIPLE_LANGUAGE = false; // 语言显示

// 匹配任意数量的数字，允许有一个小数点和小数部分
export const TRADE_REGX_NUMBER = /^\d*\.?\d*$/;

// 匹配任意数量的整数
export const TRADE_REGX_NUMBER_INTEGER = /^\d*$/;

export const dateFormat = "YYYY-MM-DD";

// 自定义DCA默认投资组合
export const DEFAULT_AD_PROPORTION: IAutoInvestCoinItem[] = [
  { currency: "BTC", percent: "65", select: true },
  { currency: "ETH", percent: "35", select: true },
];
// 语言配置
export const EN = "en";
export const ZH_CN = "zh";

export * from "./localStorageKeys";

// 排序filter点击循环顺序，默认null，再升序，再降序
export const SORT_TYPE_LIST: (ESortType | null)[] = [null, ESortType.ascend, ESortType.descend];

// 需要展示Memo的币种
export const MEMO_COINS = ["HBAR", "TON", "DYDX"];

export const LEGAL_AGREEMENT_FILE_NAME = {
  CLIENT_AND_USER_SERVICE_AGREEMENT_CSA: "Client and User Service Agreement (CSA)",
  ANNEX_A_CUSTODY_SERVICES: "Annex A: Custody Services",
  ANNEX_B_TRADING_SERVICES_MATCHED_PRINCIPAL: "Annex B: Trading Services (Matched Principal)",
  ANNEX_C_ADVISORY_AND_ARRANGING_SERVICES: "Annex C: Advisory and Arranging Services",
  ANNEX_D_MANAGING_ASSETS_SERVICES_DISCRETIONARY_MANDATES:
    "Annex D: Managing Assets Services (Discretionary Mandates)",
  RISK_DISCLOSURE_STATEMENT: "Risk Disclosure Statement",
  PRIVACY_POLICY: "Privacy Policy",
  YIELD_SERVICES_RISK_DISCLOSURE_STATEMENT: "Yield Services Risk Disclosure Statement",
};
